var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 840,
    height: 1024,
    viewBox: "0 0 840 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_436)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 840,
    height: 1024,
    fill: "url(#paint0_linear_78_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.809 655.979L427.807 1158.8H-78L25.809 655.979Z",
    fill: "#4C1D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.809 655.979L190.616 846.88L52.6115 782.11L-26.2483 904.832L25.809 655.979Z",
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.439 430.99L625.935 1147.72H41.1633L237.439 430.99Z",
    fill: "#4C1D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.975 420.763L313.834 546.893L427.195 751.429L286.726 632.117L264.547 778.701L234.975 676.433L138.864 788.928L234.975 420.763Z",
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.313 676.433L791.249 1158.8H304.65L730.313 676.433Z",
    fill: "#4C1D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.312 676.433L759.885 891.196L698.276 788.928L593.54 826.426L730.312 676.433Z",
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.733 206L662.429 1158.8H175.83L493.733 206Z",
    fill: "#4C1D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.734 206L556.641 560.529L493.734 468.488L451.839 560.529V444.625L368.051 580.983L493.734 206Z",
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.03 741.203L966.892 1160.5H592.308L837.03 741.203Z",
    fill: "#4C1D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.03 741.203L885.568 896.309L837.03 809.381L756.188 880.969L837.03 741.203Z",
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.74 840.062L679.648 1102.55H471.554L700.74 840.062Z",
    fill: "#5B21B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.448 608.254L624.345 1102.55H471.554V805.973L513.448 608.254Z",
    fill: "#5B21B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.86 880.969L885.568 1102.55H626.809L795.86 880.969Z",
    fill: "#5B21B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6827 843.471L104.363 962.784L385.301 1109.37L27.9678 1092.32L47.6827 843.471Z",
    fill: "#5B21B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_436",
    x1: 420,
    y1: 0,
    x2: 420,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#284EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75C6F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 840,
    height: 1024,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDesktop);
export default __webpack_public_path__ + "static/media/bg-desktop.dac3f681e01893dde2725b1bf23af3a0.svg";
export { ForwardRef as ReactComponent };